import { Quickchannel } from './models/quickchannel'

declare global{
    interface Window {
        Cookiebot: any;
        QuickChannel: any;
        screen9: any;
    }
}


let quickChannelObject: Quickchannel = {
    initialized: false,
    players: [],

    initialize: function(){
        if (!this.initialized && window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing && !document.getElementById("quickchannel-iframe-api")) {
            let anyVideoPlayers = document.querySelectorAll(".video-player").length;

            if (!!anyVideoPlayers) {
                let tag = document.createElement('script');
                tag.type = "text/javascript";
                tag.src = "https://cdn.screen9.com/players/iframe-api.js";
                tag.id = "quickchannel-iframe-api";
                const firstScriptTag = document.getElementsByTagName('script')[0];

                if (!!firstScriptTag) {
                    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
                    this.initialized = true;
                }
            }
        }
    },

    createPlayer: function(mediaid: string | undefined, containerid: string | undefined, onPlayerStateChange: Function){
        if (!mediaid || !containerid || this.players.some((x) => x.containerId === containerid)) {
            return;
        }

        const options = {
            containerid: containerid,
            mediaid: mediaid,
        };

        let player = new window.screen9.Player(options);

        player.on("play", function () {
              onPlayerStateChange("play", containerid)
        })

        player.on("pause", function () {
            onPlayerStateChange("pause", containerid)
        })


        this.players.push({containerId: containerid, player: player});
    },

    playVideo: function(blockElement: any) {
        const playerObject: any = this.players.find((x: { containerId: string | undefined, player: any }) => x.containerId === blockElement.dataset.containerid);

        if (playerObject?.player) {
            playerObject.player.play();
            return true;
        }

        return false;
    }
}

// If this script was loaded before QuickChannel related scripts, dispatch the loaded event again
document.addEventListener('QuickChannelRelatedScriptLoaded', function(e) {
    document.dispatchEvent(new CustomEvent("QuickChannelScriptLoaded"));
});

window.QuickChannel = quickChannelObject;

// Tell other modules that this script is loaded
document.dispatchEvent(new CustomEvent("QuickChannelScriptLoaded"));
